import { useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import { MiBox, MiDetailPageHeader, MiList } from "@miplatform/components";
import { useRouter } from "@miplatform/hooks";
import { mdiChevronLeft } from "@mdi/js";
import { Box } from "@mui/material";
import { useManageResourceRelationshipsViewModel } from "./useManageResourceRelationshipsViewModel";

export function ManageResourceRelationships() {
  const { classes } = useStyles();
  const { resourceCategories, isLoading, loadData } =
    useManageResourceRelationshipsViewModel();
  const router = useRouter();

  useEffect(() => {
    loadData();
  }, []);

  const sections = [
    {
      fieldset: [
        {
          label: "Object",
          field: "object",
          renderValue: ({ object }) =>
            object[0].toUpperCase() + object.slice(1),
        },
        {
          label: "Relationship In Use",
          field: "relationshipInUse",
          renderValue: ({ relationshipInUse }) => {
            return relationshipInUse ? "Yes" : "No";
          },
        },
      ],
    },
  ];
  return (
    <Box className={classes.contentContainer}>
      <MiDetailPageHeader
        title="Objects with Relationships"
        titleIcon={mdiChevronLeft}
        loading={isLoading}
      />
      <MiBox>
        <MiList
          viewType="card"
          cardProps={{
            sections,
            leftCardProps: { fieldset: [] },
            onClick: (item) => {
              router.navigate(
                `/settings/relationship-management/resource-relationships/${item.object}`
              );
            },
          }}
          data={resourceCategories}
          loading={isLoading}
          hideListPagination
        />
      </MiBox>
    </Box>
  );
}

const useStyles = makeStyles()(() => ({
  contentContainer: {
    display: "flex",
    flex: 1,
    overflow: "hidden",
    flexDirection: "column",
    width: "100%",
  },
}));
